import { requestService as api, getParmeter } from "../Request.service"  
const API_URL = {
  OPTION_RUNCODE: `/ERP/common/options-runcode.php`, 
  OPTION_GETLASTCODE: `/ERP/common/options-getlastcode.php`, 
  OPTION_ITEM: `/ERP/common/options-item.php`, 
  OPTION_ITEMTYPE: `/ERP/common/options-itemtype.php`,
  OPTION_MATERIAL: `/ERP/common/options-material.php`, 
  OPTION_MATERIAL_NO_PG_FG: `/ERP/common/options-material-no-pg-fg.php`,
  OPTION_PKMATERIAL: `/ERP/common/options-pk-material.php`, 
  OPTION_BUY_MATERIAL: `/ERP/common/options-buy-material.php`,
  OPTION_PG: `/ERP/common/options-pg.php`, 
  OPTION_FG: `/ERP/common/options-fg.php`,  
  OPTION_CUSTOMER: `/ERP/common/options-customer.php`, 
  OPTION_BRAND: `/ERP/common/options-brand.php`, 
  OPTION_UNIT: `/ERP/common/options-unit.php`,
  OPTION_PACKAGING: `/ERP/common/options-packaging.php`,
  OPTION_PACKING: `/ERP/common/options-packing.php`,
  OPTION_SUPPLIER: `/ERP/common/options-supplier.php`,
  OPTION_BOMFORPI: `/ERP/common/options-bom-for-pi.php`,
  OPTION_JO: `/ERP/common/options-jo.php`,
  OPTION_RD_BOM: `/ERP/common/options-rd-bom.php`,

};
 

const OptionService = () => {
  const optionsRuncode = (parm = {}) => api.get(`${API_URL.OPTION_RUNCODE}?${getParmeter(parm)}`, { ignoreLoading : true });  
  const optionsGetLastcode = (parm = {}) => api.get(`${API_URL.OPTION_GETLASTCODE}?${getParmeter(parm)}`, { ignoreLoading : true });  
  const optionsItems = (parm = {}) => api.get(`${API_URL.OPTION_ITEM}?${getParmeter(parm)}`, { ignoreLoading : true });  
  const optionsItemType = () => api.get(`${API_URL.OPTION_ITEMTYPE}`, { ignoreLoading : true }); 
  const optionsMaterial = (parm = {}) => api.get(`${API_URL.OPTION_MATERIAL}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsMaterial_noPGFG = (parm = {}) => api.get(`${API_URL.OPTION_MATERIAL_NO_PG_FG}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsPKMaterial = (parm = {}) => api.get(`${API_URL.OPTION_PKMATERIAL}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsBuyMaterial = (parm = {}) => api.get(`${API_URL.OPTION_BUY_MATERIAL}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsPG = (parm = {}) => api.get(`${API_URL.OPTION_PG}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsFG = (parm = {}) => api.get(`${API_URL.OPTION_FG}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsCustomer = (parm = {}) => api.get(`${API_URL.OPTION_CUSTOMER}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsBrand = (parm = {}) => api.get(`${API_URL.OPTION_BRAND}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsUnit = () => api.get(`${API_URL.OPTION_UNIT}`, { ignoreLoading : true });
  const optionsPackaging = (parm = {}) => api.get(`${API_URL.OPTION_PACKAGING}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsPacking = (parm = {}) => api.get(`${API_URL.OPTION_PACKING}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsSupplier = (parm = {}) => api.get(`${API_URL.OPTION_SUPPLIER}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsBomforPI = (parm = {}) => api.get(`${API_URL.OPTION_BOMFORPI}?${getParmeter(parm)}`, { ignoreLoading : true });
  const optionsJO = (parm = {}, config = {}) => api.post(`${API_URL.OPTION_JO}`, parm, { ...config });
  /* สูตร BOM ฝั่ง RD — ไม่ส่ง id = รายการสูตรทั้งหมด, ส่ง id = รายละเอียดสูตรนั้น */
  const optionsRdBom = (parm = {}) => api.get(`${API_URL.OPTION_RD_BOM}?${getParmeter(parm)}`, { ignoreLoading : true });
  return {
    optionsRuncode,
    optionsGetLastcode,
    optionsItems,    
    optionsItemType,
    optionsMaterial,
    optionsMaterial_noPGFG,
    optionsPKMaterial,
    optionsBuyMaterial,
    optionsPG,
    optionsFG,
    optionsCustomer,
    optionsBrand,
    optionsUnit,
    optionsPackaging,
    optionsPacking,
    optionsSupplier,
    optionsBomforPI,
    optionsRdBom,
    optionsJO,
  };
};

export default OptionService;